import * as React from 'react';
import {
    setPlanesDesdeBusqueda,
    setPlanes,
    setDataGrupoCopy,
    setEditando
} from '../../actions/planesActions';
import { connect } from 'react-redux';
import { getPlanesPorParametros } from '../../api/axios';
import ReactPaginate from 'react-paginate';
import BigSpinner from '../General/BigSpinner';
import GoBackArrow from '../General/GoBackArrow';
import { withNavigation } from '../General/withNavigation';

class Busqueda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            IdPlataforma: 0,
            Numero: null,
            IdPlan: null,
            Page: 1,
            PageSize: 10,
            CantidadTotal: 0,
            Descripcion: "",
            planes: [],
            planesToSend: [],
            isLoading: false,
            // nuevo: control de checks por n├║mero de plan
            selectedNums: new Set()
        };
    }


    seedSelectedFromProps = (props) => {

        let lstPlanes;

        if (Array.isArray(props.planDesdeBusqueda) && props.planDesdeBusqueda.length > 0) {

            const listaPlanes = {
                elementos: props.planDesdeBusqueda.map(p => ({
                    idPlan: p.id,
                    numeroPlan: p.numero,
                    descripcion: p.descripcion,
                    cuotas: p.cuotas
                }))
            };

            lstPlanes = listaPlanes;
        } else {
            lstPlanes = this.props.planes;
        }


        //let lstPlanes = this.state.planes?.elementos;
        //if (!lstPlanes || lstPlanes.length === 0) {
        //    lstPlanes = this.props.planes?.elementos;
        //}
        const fromElementos = (lstPlanes.elementos ?? []).map(p => p.numeroPlan).filter(n => n != null);

        const setNums = new Set(fromElementos);

        const planesToSend = (lstPlanes.elementos ?? []).map(pl => ({
            numero: pl.numeroPlan ?? pl.numero,
            descripcion: pl.descripcion,
            cuotas: pl.cuotas,
            id: pl.idPlan ?? pl.id
        }));

        this.props.setPlanesDesdeBusqueda(planesToSend);
        this.setState({ selectedNums: setNums, planesToSend });
    };


    syncPlanesToSendFromNums = (numsSet, planesLista) => {
        if (!Array.isArray(planesLista)) return [];
        return planesLista
            .filter(pl => numsSet.has(pl.numero))
            .map(pl => ({
                numero: pl.numero,
                descripcion: pl.descripcion,
                cuotas: pl.cuotas,
                id: pl.idPlan ?? pl.id
            }));
    };

    togglePlan = (plan, checked) => {
        this.setState(prev => {
            const selectedNums = new Set(prev.selectedNums);
            const planesToSend = [...prev.planesToSend];

            if (checked) {
                selectedNums.add(plan.numero);
                if (!planesToSend.some(x => x.numero === plan.numero)) {
                    planesToSend.push({
                        numero: plan.numero,
                        descripcion: plan.descripcion,
                        cuotas: plan.cuotas,
                        id: plan.idPlan ?? plan.id
                    });
                }
            } else {
                selectedNums.delete(plan.numero);
                const i = planesToSend.findIndex(x => x.numero === plan.numero);
                if (i !== -1) planesToSend.splice(i, 1);
            }

            this.props.setPlanesDesdeBusqueda(planesToSend);
            return { selectedNums, planesToSend };
        });
    };

    componentDidMount() {
        this.requestChange();
        this.props.setDataGrupoCopy(this.props.dataGrupo);

        if (this.props.idGrupo == 0) {
            this.props.setPlanesDesdeBusqueda([]);
            this.props.setPlanes([]);
        } else {
            if (this.props.idGrupo == "Nuevo") {
                this.props.setPlanes([]);
            }
            const jsonPlanDesdeBusqueda = JSON.stringify(this.props.planDesdeBusqueda);
            if (jsonPlanDesdeBusqueda !== "[]") {
                this.format_PlanesEnGrupo(this.props.planDesdeBusqueda);
            } else {
                this.format_PlanesEnGrupo(this.props.planesEnGrupo);
            }
        }

        this.seedSelectedFromProps(this.props);
    }

    //componentDidUpdate(prevProps) {
    //    if (prevProps.planes !== this.props.planes ||
    //        prevProps.planDesdeBusqueda !== this.props.planDesdeBusqueda) {
    //        this.seedSelectedFromProps(this.props);
    //    }
    //}

    format_PlanesEnGrupo = (listaObjeto) => {
        let newArr = [];
        if (listaObjeto != undefined) {
            for (let index = 0; index < listaObjeto.length; index++) {
                const element = listaObjeto[index];
                let newObj = {
                    numero: element.numeroPlan != null ? element.numeroPlan : element.numero,
                    descripcion: element.descripcion,
                    cuotas: element.cuotas,
                    id: element.idPlan != null ? element.idPlan : element.id
                };
                newArr.push(newObj);
            }
            this.setState({ planesToSend: newArr });
            this.props.setPlanesDesdeBusqueda(newArr);
        }
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        this.setState({ Page: selectedPage }, this.requestChange);
    };

    myChangeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value }, this.requestChange);
    };


    requestChange = () => {
        this.setState({ isLoading: true });
        setTimeout(() => {
            //const params = {
            //    IdPlataforma: 1,
            //    Numero: this.state.Numero,
            //    IdPlan: this.state.IdPlan,
            //    Page: this.state.Numero ? 1 : this.state.Page,
            //    PageSize: this.state.PageSize,
            //    Descripcion: this.state.Descripcion
            //};
            const params = {
                IdPlataforma: 1,
                Numero: this.state.Numero,
                IdPlan: this.state.IdPlan,
                Page: this.state.Numero ? 1 : this.state.Page,
                PageSize: this.state.PageSize,
                Descripcion: this.state.Descripcion
            };

            const listaPlanes = getPlanesPorParametros(params);
            listaPlanes.then((res) => {
                const planes = res.data?.elementos ?? [];
                this.setState({
                    planes,
                    CantidadTotal: res.data.cantidadTotal,
                    Page: res.data.numeroPagina,
                    isLoading: false
                    // ­ƒæç Ojo: NO tocamos planesToSend ac├í,
                    // se maneja solo en togglePlan
                });
            });
        }, 500);
    };



    onSubmit = async (event) => {
        event.preventDefault();
    };

    return = () => {
        this.props.setPlanesDesdeBusqueda([]);
        this.props.navigate("/Planes");
    };

    onEdit = (id) => {
        this.props.navigate(`/Planes/Editar/${id}`);
    };

    onNew = () => {
        this.props.navigate("/Planes/Nuevo");
    };

    onBack = () => {
        this.props.navigate("/Planes");
    };

    agregarPlanes = () => {
        this.props.setEditando(true);
        const { idGrupoPlan } = this.props;
        const vieneDeEditar =
            idGrupoPlan !== undefined &&
            idGrupoPlan !== null &&
            idGrupoPlan !== 'Nuevo' &&
            !Number.isNaN(Number(idGrupoPlan)) &&
            Number(idGrupoPlan) > 0;

        this.props.setPlanesDesdeBusqueda(this.state.planesToSend);

        if (vieneDeEditar) {
            this.props.navigate(`/Planes/Editar/${idGrupoPlan}`);
        } else {
            this.props.navigate('/Planes/Nuevo');
        }
    };


    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="col-10 col-md-5 mb-4">
                                    <GoBackArrow onBack={this.onBack} />
                                    <h4 className="card-title d-block d-sm-inline">Búsqueda de Planes</h4>
                                </div>

                                <div className="row form-material p-4 p-md-0">
                                    <div className="col-12 col-md-3 offset-md-1">
                                        <label className="label-oscura">Número Plan</label>
                                        <input
                                            onChange={this.myChangeHandler}
                                            name="Numero"
                                            type="number"
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-12 col-md-4 col-12 col-md-1">
                                        <label className="label-oscura">Descripcion</label>
                                        <input
                                            onChange={this.myChangeHandler}
                                            className="form-control"
                                            name="Descripcion"
                                            type="text"
                                        />
                                    </div>
                                </div>

                                {this.state.isLoading ? (
                                    <BigSpinner />
                                ) : this.state.planes.length > 0 ? (
                                    <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>

                                        {this.state.planes.map((plan, index) => (
                                            <div className="list-group" key={index}>
                                                <a>
                                                    <div className="list-group-item hover-background-color">
                                                        <div className="row justify-content-between align-items-center">
                                                            <div className="col-2 col-md-1">
                                                                <h6 className="box-title font-weight-bold text-center">{plan.numero}</h6>
                                                            </div>

                                                            <div className="col-6 col-md-6 text-break">
                                                                <small className="font-14 applyFont">{plan.descripcion}</small>
                                                            </div>

                                                            <div className="col-2 col-md-1 custom-control custom-checkbox">
                                                                <input
                                                                    name="checkBoxes"
                                                                    type="checkbox"
                                                                    className="custom-control-input allow-pointer-cursor"
                                                                    id={"check" + plan.numero}
                                                                    checked={this.state.selectedNums.has(plan.numero)}
                                                                    onChange={(e) => {
                                                                        e.stopPropagation();
                                                                        this.togglePlan(plan, e.target.checked);
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        ))}

                                        <div className="d-flex justify-content-center">
                                            <ReactPaginate
                                                previousLabel={"Anterior"}
                                                nextLabel={"Siguiente"}
                                                breakLabel={"..."}
                                                breakClassName={"break-me"}
                                                pageCount={this.state.CantidadTotal / this.state.PageSize}
                                                marginPagesDisplayed={1}
                                                pageRangeDisplayed={2}
                                                onPageChange={this.handlePageClick}
                                                containerClassName={"pagination"}
                                                subContainerClassName={"pages pagination"}
                                                activeClassName={"active"}
                                                forcePage={this.state.Page - 1}
                                            />
                                        </div>

                                        <div className="d-flex justify-content-center">
                                            <button
                                                onClick={this.agregarPlanes}
                                                className="btn btn-sm background-rojo-megatone waves-light m-r-10"
                                                type="button"
                                            >
                                                Guardar
                                            </button>

                                            <button
                                                onClick={this.return}
                                                className="btn btn-sm btn-light waves-effect waves-light"
                                                type="button"
                                            >
                                                Salir
                                            </button>
                                        </div>

                                    </form>
                                ) : (
                                    <div className='text-center'>
                                        <h5 className="d-flex justify-content-center my-4">NO SE ENCONTRARON RESULTADOS</h5>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    dataGrupo: state.planes.dataGrupo,
    idGrupo: state.planes.idGrupo,
    planDesdeBusqueda: state.planes.planesDesdeBusqueda,
    planesEnGrupo: state.planes.planesEnGrupo,
    editando: state.planes.editando,
    idGrupoPlan: state.planes.dataGrupo.idGrupoPlan,
    planes: state.planes.grupoPorId
});

const mapDispatchToProps = {
    setPlanesDesdeBusqueda,
    setPlanes,
    setDataGrupoCopy,
    setEditando
};

export default withNavigation(connect(mapStateToProps, mapDispatchToProps)(Busqueda));